/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminConfig } from '../../../../features/adminConfigSlice';
import {
  getAdminConfigState,
} from '../../../../state/selectors/adminConfig.selector';
import { TableConfig } from './components';

const ConfigAdmin = (props) => {
  const dispatch = useDispatch();
  const adminConfig = useSelector(getAdminConfigState);
  useEffect(() => {
    dispatch(getAdminConfig());
  }, []);
  return (
    <div>
      <TableConfig configData = {adminConfig}/>
    </div>
  );
};

export default ConfigAdmin;
